import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: number;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  author,
  publishDate,
  readTime,
  imageUrl,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${category}`}
              className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500/90 text-white hover:bg-primary-600 transition-colors duration-200"
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 mb-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
            {excerpt}
          </p>
          <div className="flex flex-wrap items-center gap-2 mb-3">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700"
              >
                {tag}
              </span>
            ))}
          </div>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {publishDate}
              </span>
            </div>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}分钟阅读
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}